import { THERAPY_STEPS } from "../data/site";
import { Icon } from "./Icon";
import { Reveal } from "./Reveal";

export const Timeline = ({ dark = false }) => (
    <div className="relative mx-auto mt-14 max-w-6xl">
        <div
            className={`absolute left-6 top-0 h-full w-px md:left-0 md:top-10 md:h-px md:w-full ${
                dark ? "bg-white/10" : "bg-teal/15"
            }`}
        />
        <ol className="grid gap-10 md:grid-cols-5 md:gap-6">
            {THERAPY_STEPS.map((step, i) => (
                <Reveal key={step.title} delay={i * 0.1}>
                    <li className="relative flex gap-5 md:flex-col md:gap-0" data-testid={`timeline-step-${i + 1}`}>
                        <div className="relative z-10 flex flex-col items-center">
                            <span
                                className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl border transition-transform duration-500 hover:scale-110 md:h-20 md:w-20 md:rounded-3xl ${
                                    dark
                                        ? "border-aqua/25 bg-white/5 text-aqua"
                                        : "border-teal/20 bg-white text-teal shadow-lg shadow-teal/10"
                                }`}
                            >
                                <Icon name={step.icon} size={22} strokeWidth={1.8} />
                            </span>
                        </div>
                        <div className="md:mt-6 md:text-center">
                            <p className={`font-jakarta text-xs font-bold tracking-[0.2em] ${dark ? "text-peach" : "text-peach-deep"}`}>
                                STEP {String(i + 1).padStart(2, "0")}
                            </p>
                            <h3 className={`mt-1.5 font-jakarta text-lg font-bold ${dark ? "text-cream" : "text-navy"}`}>
                                {step.title}
                            </h3>
                            <p className={`mt-2 text-sm leading-relaxed ${dark ? "text-cream/60" : "text-ink/65"}`}>
                                {step.description}
                            </p>
                        </div>
                    </li>
                </Reveal>
            ))}
        </ol>
    </div>
);
